enum Policy {
    BASIC_ACCESS = "BasicAccess",
    SYS_ADMIN = "SysAdmin",
}
export { Policy };
